<template>
  <v-card outlined>
    <v-card-title>
      <span class="text-h4" :class="(cajaInputType == 'salida') ? 'red--text':'green--text'">{{title}} Caja</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field 
              v-model="cantidad"
              label="Cantidad*" 
              type="number" 
              outlined 
              autofocus
              placeholder="0"
              required
              :color="(cajaInputType == 'salida') ? 'red':'green'"
              class="text-h4 font-weight-black"
              prepend-inner-icon="mdi-currency-usd"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="concepto"
              :color="(cajaInputType == 'salida') ? 'red':'green'"
              label="*Concepto"
              :hint="conceptoHint"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <small>*indica los campos requeridos</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancel">
        Cancelar
      </v-btn>
      <v-btn 
        :disabled="cantidad <= 0 || concepto.length ==0 "
        :color="(cajaInputType == 'salida')?'red':'green'" 
        text
        @click="save">Guardar </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// const { registrarMovimiento } = api.services.cajaService; 
export default {
  name: "CajaInput",
  props: {
    cajaInputType: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      cantidad: null,
      concepto: '',
    };
  },
  computed: {
    ...mapGetters(['user']),
    title(){
      return `${this.cajaInputType.charAt(0).toUpperCase() + this.cajaInputType.slice(1)}s`;
    },
    conceptoHint(){
      return `Por favor describe el concepto por el cual se hace la ${this.cajaInputType}`;
    },
  },
  methods: {
    ...mapActions(['closeCajaModal']),
    registrarMovimiento(){},
    resetInputData(){
      this.cantidad = null;
      this.concepto = '';
    },
    save(){
      const tipo = (this.cajaInputType == 'entrada') ? 'deposito':'retiro';
      const monto = this.cantidad;
      const concepto = this.concepto;
      const idUsuario = this.user.id;
      const result = this.registrarMovimiento(tipo, monto, concepto, idUsuario);
      if(result){
        this.closeCajaModal();
        this.$emit('new-movimiento-added');
        this.resetInputData();
      }
    },
    cancel(){
      this.resetInputData();
      this.$emit('close-caja-modal');
    }
  }
}
</script>